import { axiosPrivate } from "../../util/axios";
import { EquipmentListProps } from "../../types/baseTypes";

/**
 * Fetch equipment/services (groups include price) for a given location.
 * Optional `types` can be passed to filter server-side.
 */
export async function fetchLocationEquipment(
  locationId: string,
  types?: string,
  customerAgreementId?: string
): Promise<EquipmentListProps[]> {
  let url = `/location/${encodeURIComponent(locationId)}/groups/include-price`;
  const params = new URLSearchParams();
  if (types) params.set("types", types);
  if (customerAgreementId) params.set("customerAgreementId", customerAgreementId);
  const query = params.toString();
  if (query) url += `?${query}`;
  const { data } = await axiosPrivate.get<EquipmentListProps[]>(url);
  return data ?? [];
}
